import {
    Applicant,
    Applicants,
    ApplicantQualification,
    ApplicantQualificationDetails,
    ApplicantExamList,
    ISetApplicantTempPassword,
    SetApplicantTempPassword,
    ApplicantIdentityDoc,
} from '../../api/ApiClient';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: State = {
    applicantList: null,
    applicantDetail: null,
    applicantQualifications: null,
    applicantQualificationDetails: null,
    applicantArchiveExams: null,
    applicantIdentityDoc: null,
};

const applicants = createModel({
    state: initialState,
    reducers: {
        setApplicantList(state: State, userList: Applicants | null): State {
            return { ...state, applicantList: userList };
        },
        setApplicantDetail(state: State, applicantDetail: Applicant | null): State {
            return { ...state, applicantDetail };
        },
        cleanApplicantDetail(state: State): State {
            return { ...state, applicantDetail: null };
        },
        setApplicantQualifications(state: State, applicantQualifications: ApplicantQualification[] | null): State {
            return { ...state, applicantQualifications };
        },
        setApplicantQualificationsDetail(state: State, applicantQualificationDetails: ApplicantQualificationDetails | null): State {
            return { ...state, applicantQualificationDetails };
        },
        setApplicantArchiveExams(state: State, applicantArchiveExams: ApplicantExamList | null): State {
            return { ...state, applicantArchiveExams };
        },
        setApplicantIdentityDoc(state: State, applicantIdentityDoc: ApplicantIdentityDoc | null): State {
            return { ...state, applicantIdentityDoc };
        },
    },
    effects: (dispatch: any) => ({
        async getApplicantListAsync({
            searchField, searchTerm, page, pageSize, sortOrder, sortField,
        }: IGetApplicantsProps) {
            const applicantQualifications = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicants(searchField, searchTerm, page, pageSize, sortOrder, sortField));
            this.setApplicantList(applicantQualifications);
        },
        async getApplicantAsync({ applicantId }: IGetApplicantDetailProps) {
            const applicantDetail = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicant(applicantId));
            this.setApplicantDetail(applicantDetail);
        },
        async getApplicantQualificationsAsync({ applicantId }: IGetApplicantQualificationsProps) {
            const applicantDetail = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantQualifications(applicantId));
            this.setApplicantQualifications(applicantDetail);
        },
        async getApplicantQualificationDetailsAsync({ applicantId, examApplicationId }: IGetApplicantQualificationDetailProps) {
            const applicantQualificationDetails = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantQualificationDetails(applicantId, examApplicationId));
            this.setApplicantQualificationsDetail(applicantQualificationDetails);
        },
        async getApplicantArchiveExamsAsync({
            applicantId, searchField, searchTerm, page, pageSize, sortOrder, sortField,
        }: IGetApplicantArchiveExamsProps) {
            const applicantArchiveExams = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantArchiveExams(applicantId, searchField, searchTerm, page, pageSize, sortOrder, sortField));
            this.setApplicantArchiveExams(applicantArchiveExams);
        },
        async setApplicantTempPasswordAsync({ applicantId, body }: ISetApplicantTempPass) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.setApplicantTempPassword(applicantId, new SetApplicantTempPassword(body)));

            if (res) {
                dispatch.notifications.addNotification([{ message: 'Временный пароль успешно добавлен', appearance: 'success' }] as INotification[]);
            }

            return res;
        },
        async getApplicantByPhoneAsync(phone: string) {
            this.setApplicantDetail(null);
            const applicantDetail = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantByPhone(phone));
            this.setApplicantDetail(applicantDetail);

            return applicantDetail;
        },
        async getApplicantIdentityDocAsync(applicantId: string) {
            const applicantIdentityDoc = await apiConnector.execApi(dispatch, apiClient => apiClient.getIdentityDoc(applicantId));

            this.setApplicantIdentityDoc(applicantIdentityDoc);
        },
        clearApplicantDetail() {
            this.setApplicantDetail(null);
            this.setApplicantIdentityDoc(null);
        },
    }),
});

export default applicants;

interface State {
    applicantList: Applicants | null;
    applicantDetail: Applicant | null;
    applicantQualifications: ApplicantQualification[] | null;
    applicantQualificationDetails: ApplicantQualificationDetails | null;
    applicantArchiveExams: ApplicantExamList | null;
    applicantIdentityDoc: ApplicantIdentityDoc | null;
}

interface IGetApplicantsProps {
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IGetApplicantDetailProps {
    applicantId: string;
}

interface IGetApplicantQualificationsProps {
    applicantId: string;
}

interface IGetApplicantQualificationDetailProps {
    applicantId: string;
    examApplicationId: string;
}

interface IGetApplicantArchiveExamsProps {
    applicantId: string;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface ISetApplicantTempPass {
    applicantId: string;
    body: ISetApplicantTempPassword;
}
